import { sva } from "styled-system/css";

export const failedScheduledPaymentRecipe = sva({
  slots: ["container", "text"],
  base: {
    container: {
      flexDir: "column",
      border: "2px solid",
      borderRadius: "150",
      p: "400",
      gap: "200",
    },
  },
  variants: {
    color: {
      warning: {
        container: {
          borderColor: "border.warning",
          bgColor: "bg.warning.lightest",
        },
        text: {
          color: "text.warning.dark",
        },
      },
      success: {
        container: {
          borderColor: "border.success",
          bgColor: "bg.success.lightest",
        },
        text: {
          color: "text.success.dark",
        },
      },
    },
  },
  defaultVariants: {
    color: "warning",
  },
});
